import { render, staticRenderFns } from "./sampleProper.vue?vue&type=template&id=7835d966&scoped=true&"
import script from "./sampleProper.vue?vue&type=script&lang=js&"
export * from "./sampleProper.vue?vue&type=script&lang=js&"
import style0 from "./sampleProper.vue?vue&type=style&index=0&id=7835d966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7835d966",
  null
  
)

export default component.exports